<template>
	<b-modal
		ref="modal-view"
		size="xl"
		title="Seleccionar ubicación"
		scrollable
	>
		<template #default="{}">
			<b-overlay :show="saveLocation" no-wrap></b-overlay>
			<b-card no-body class="notBorder">
				<div class="search-box">
					<b-form @submit.prevent="search">
						<b-form-row>
							<b-form-group class="col-2" label="Buscar por">
								<b-form-select v-model="searchType">
									<option value="name">Nombre</option>
									<option value="place_id">Place ID</option>
								</b-form-select>
							</b-form-group>
							<b-form-group class="col-8" :label="searchType === 'name' ? 'Nombre' : 'Google Place ID'">
								<b-form-input v-model="name" type="text" :placeholder="searchType === 'name' ? 'Ingresa el nombre del lugar' : 'Ingresa el Google Place ID'" />
							</b-form-group>
							<b-form-group class="col-2" label=".">
								<b-button type="submit" block variant="primary"
									>Buscar</b-button
								>
							</b-form-group>
						</b-form-row>
						
						<b-form-row  class="listResult">
							<b-alert show variant="info" class="fullW"
								>Ingrese el nombre del elemento que quiere
								buscar, después seleccione el que corresponda
								con la ubicación buscada.</b-alert
							>
						</b-form-row>
						<b-form-row class="listResult">
							<b-alert
								show
								variant="warning"
								class="fullW"
								v-if="locations.length < 1 && !loading"
								>No existen resultados para su consulta, intente
								con otras palabras.</b-alert
							>
							<b-list-group class="fullW scrollable-list">
								<b-list-group-item v-if="loading">
									<b-skeleton
										animation="wave"
										width="85%"
									></b-skeleton>
									<b-skeleton
										animation="wave"
										width="55%"
									></b-skeleton>
									<b-skeleton
										animation="wave"
										width="70%"
									></b-skeleton>
								</b-list-group-item>

								<b-list-group-item
									href="#"
									class="flex-column align-items-start"
									v-for="(item, i) in locations"
									:key="i"
									:active="i === select"
									@click.prevent="selectItem(i)"
								>
									<div
										class="d-flex w-100 justify-content-between"
									>
										<h5 class="mb-1">
											{{ item.name }}
										</h5>
										<small
											>Rating:
											{{ item.rating || "NA" }}</small
										>
									</div>

									<p class="mb-1">
										{{ item.formatted_address }}
									</p>
									<small
										>Google place id:
										{{ item.place_id || "NA" }}</small
									>
								</b-list-group-item>
							</b-list-group>
						</b-form-row>
						
						<!-- Map Section -->
						<b-form-row v-show="showMap" class="listResult">
							<div class="fullW">
								<h6>Ubicación en el Mapa</h6>
								<gMap 
									ref="mapComponent"
									@mounted="onMapMounted"
								/>
							</div>
						</b-form-row>
					</b-form>
				</div>
			</b-card>
		</template>

		<template #modal-footer="{ cancel }">
			<b-button variant="danger" @click="cancel()">
				Cancelar
			</b-button>

			<b-button variant="info" @click="openGM()" v-if="googleLink">
				<md-icon icon="place" /> Ubicar en el Mapa
			</b-button>

			<b-button
				v-if="!empty"
				variant="success"
				:disabled="(select < 0 || saveLocation) && !$hasPermission('place.location.assign')"
				@click.prevent="updateLocationGp"
			>
				Asignar Dirección
			</b-button>
		</template>
	</b-modal>
</template>

<script>
import gMap from "../rate-plans/Map.vue";

export default {
	components: {
		gMap
	},
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	data() {
		return {
			idPlace: -1,
			loading: false,
			saveLocation: false,
			name: "",
			searchType: "name",
			locations: [],
			select: -1,
			empty: false,
			googleLink: null,
			showMap: false,
			mapMounted: false
		};
	},
	methods: {
		loadModel(model, newPlace) {
			this.$refs["modal-view"].show();
			this.name = model.name;
			this.idPlace = model.id;
			if (!newPlace && this.name === "") {
				this.empty = true;
			} else {
				this.search();
			}
		},
		search() {
			this.loading = true;
			this.select = -1;
			this.locations = [];
			this.googleLink = null;
			
			const payload = this.searchType === "place_id" ? 
				{ place_id: this.name } : 
				{ name: this.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") };
			
			this.$root.api
				.post(`/places/locations`, payload)
				.then(res => {
					if (res.data.response.status === "OK") {
						this.locations = res.data.response.results;
						this.loading = false;
					} else if (res.data.response.status === "ZERO_RESULTS") {
						this.loading = false;
					} else {
						this.$root.showAlert(
							`Ocurrio un problema al buscar la ubicación.`
						);
						this.$refs["modal-view"].hide();
					}
				})
				.catch(() => {
					this.$root.showAlert(`No fue posible buscar la ubicación.`);
					this.$refs["modal-view"].hide();
				});
		},
		selectItem(index) {
			this.select = index;
			this.extractGoogleLink(this.locations[index]);
			if (!this.showMap) {
				this.showMap = true;
			}
			if (this.mapMounted) {
				this.addMarkerToMap();
			}
		},
		updateLocationGp() {
			const googlePlaceId = this.locations[this.select].place_id;
			this.saveLocation = true;
			this.$root.api
				.get(`/places/locations/${googlePlaceId}`, { googlePlaceId })
				.then(res => {
					// el nombre del objeto a actualizar se debe mantener
					delete res.data.response.name
					this.successCallback({
						...res.data.response,
						...{ googlePlaceId }
					});
				})
				.catch(() => {
					this.$root.showAlert(
						`No fue posible actualizar los datos de la ubicación.`
					);
				})
				.finally(() => {
					this.saveLocation = false;
					this.$refs["modal-view"].hide();
				});
		},
		extractGoogleLink(data) {
			const lat = data.geometry.location.lat;
			const lgn = data.geometry.location.lng;
			if (data.geometry.location) {
				this.googleLink = `http://www.google.com/maps/place/${lat},${lgn}`;
				return;
			}
			this.googleLink = null;
		},
		openGM () {
			if (this.select >= 0 && this.locations[this.select]) {
				const location = this.locations[this.select];
				const lat = location.geometry.location.lat;
				const lng = location.geometry.location.lng;
				const url = `https://www.google.com/maps/@${lat},${lng},15z`;
				window.open(url, '_blank');
			}
		},
		onMapMounted() {
			console.log("mounted")
			this.mapMounted = true;
			if (this.select >= 0) {
				this.addMarkerToMap();
			}
		},
		addMarkerToMap() {
			if (this.$refs.mapComponent && this.locations[this.select]) {
				const location = this.locations[this.select];
				const marks = [{
					latitude: location.geometry.location.lat,
					longitude: location.geometry.location.lng,
					content: `<strong>${location.name}</strong><br>${location.formatted_address}`,
					label: "📍"
				}];
				this.$refs.mapComponent.createMarks(marks);
			}
		}
	},
	computed: {}
};
</script>

<style>
.notBorder {
	border: 0px;
}

.fullW {
	width: 100%;
}

.search-box {
	padding: 30px;
	padding-top: 0;
}

.search-box .listResult {
	margin-top: 20px;
	padding-left: 5px;
	padding-right: 5px;
}

.scrollable-list {
	max-height: 300px;
	overflow-y: auto;
}
</style>
